import type {
  BenchmarkQuery,
  DiagnosisContext,
  DiagnosisReport,
  DiagnosisResult,
} from './contracts';
import { buildActionPlan } from './action-plan';
import { lookupBenchmarks } from './benchmarks';

export function buildDiagnosisReport(
  context: DiagnosisContext,
  result: DiagnosisResult,
  benchmarkQueries: readonly BenchmarkQuery[] = [],
  now = new Date(),
): DiagnosisReport {
  const benchmarkSummary = benchmarkQueries.map((query) =>
    lookupBenchmarks(context.benchmarks ?? [], query),
  );
  const actionPlan = buildActionPlan(result.items, result.coverage.overall);
  const evidence = result.items.flatMap((item) => item.evidence);
  return {
    funnelContext: { nodeCount: context.graph.nodes.length, edgeCount: context.graph.edges.length },
    scenarioContext: result.context.scenario,
    ...(result.context.target ? { targetContext: result.context.target } : {}),
    coverage: result.coverage,
    confidence: result.items.length
      ? result.items.reduce((sum, item) => sum + item.confidence, 0) / result.items.length
      : result.coverage.overall,
    scores: result.scores,
    bottlenecks: result.items.filter((item) => item.type === 'bottleneck'),
    opportunities: result.items.filter((item) => item.type === 'opportunity'),
    risks: result.items.filter(
      (item) =>
        item.type === 'risk' ||
        item.type === 'inconsistency' ||
        item.type === 'data_gap' ||
        item.type === 'goal_gap',
    ),
    benchmarkSummary,
    actionPlan,
    evidenceSummary: {
      count: evidence.length,
      sources: [...new Set(evidence.map((item) => item.source))].sort(),
    },
    warnings: [...new Set([...result.warnings, ...actionPlan.warnings])],
    generatedAt: now.toISOString(),
  };
}
